import React from 'react';
import { DateField, Show, TextField } from 'react-admin';
import { AmountField } from 'cw-core-admin-ui/src/components/fields';
import { Grid, GridShowLayout } from 'cw-core-admin-ui/src/components/wrapper';
import InvoiceVoucherShowActions from './InvoiceVoucherShowActions';

export default (props) => {
	return (
		<Show {...props} actions={<InvoiceVoucherShowActions />}>
			<GridShowLayout>
				<Grid container spacing={2}>
					<Grid item xs={12} md>
						<TextField source="id" />
						<TextField source="code" />
						<TextField source="description" />
						<TextField source="marketingAction" />
					</Grid>
					<Grid item xs={12} md>
						<AmountField source="amount" />
						<TextField source="status" />
						<DateField source="creationDateTime" showTime />
					</Grid>
				</Grid>
			</GridShowLayout>
		</Show>
	);
};
